module.exports = __webpack_public_path__ + "img/unstabilized.b8e0e8f9.png";